var render = function render(){var _vm=this,_c=_vm._self._c;return _c('m-select',_vm._b({staticClass:"analysis__year",style:('min-width: 140px; width: 140px;'),attrs:{"value":_vm.value,"items":_vm.years,"placeholder":`${new Date().getFullYear()}`,"clearable":false,"suffix":"год"},on:{"input":function($event){return _vm.$emit('input', $event)}}},'m-select',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }